import React from "react";
import { GlobalStore } from "../../../store/global/GlobalStore";
import { Token } from "../../../store/global/TokenEnum";
import { Amount } from "../../../types/amount";
import { WrapQuote, WrapType } from "../../../types/wrapQuote";
import { ReverseTokensButton } from "../../../components/ReverseTokens/ReverseTokensButton";
import { WrapLeg } from "./WrapLeg";
import { WrapProps } from "../Wrap";

export const initialWrapQuote = {
  type: "Wrapping",
  amount: undefined,
  max: false,
  gas: Amount.ZERO,
  hash: undefined,
  warning: undefined,
  error: undefined,
} as WrapQuote;

export const WrapEntry: React.FC<WrapProps> = ({ takerToken, makerToken }) => {
  const { balances } = GlobalStore.useState(s => {
    return {
      balances: s.balances,
    };
  });

  const makerBalance = balances.find(entry => entry.symbol === makerToken);
  const takerBalance = balances.find(entry => entry.symbol === takerToken);
  const switchWrapTokens = () => {
    GlobalStore.update(s => {
      // if wrapQuote is undefined or null, initialize with default properties
      if (!s.wrapQuote) {
        s.wrapQuote = {
          type: WrapType.Wrapping,
          amount: undefined,
          max: false,
          gas: Amount.ZERO,
          hash: undefined,
          warning: undefined,
          error: undefined,
        };
      } else {
        // if wrapQuote is defined, switch the type and keep other properties same
        s.wrapQuote = {
          ...s.wrapQuote, // keep other properties same
          amount: undefined,
          warning: undefined,
          type: s.wrapQuote.type === WrapType.Wrapping ? WrapType.Unwrapping : WrapType.Wrapping, // switch the type
        };
      }
    });
  };

  return (
    <>
      <div className="d-flex justify-content-between">
        <div className="trade-box-header">You Pay</div>
      </div>
      <WrapLeg
        token={takerToken}
        balance={takerBalance ?? { symbol: Token.WETH, balance: Amount.ZERO }}
        counterParty={"taker"}
      />
      <ReverseTokensButton isVisible={true} onClick={switchWrapTokens} isWrap={true} />
      <div className="d-flex justify-content-between">
        <div className="trade-box-header">You Receive Exactly</div>
      </div>
      <WrapLeg
        token={makerToken}
        balance={makerBalance ?? { symbol: Token.WETH, balance: Amount.ZERO }}
        counterParty={"maker"}
      />
    </>
  );
};
